import {
  onMounted, ref, watch,
} from 'vue';
import { ManagementFrameTitleItem } from './types';

export default function managementFrameTitleFun(props: {items: ManagementFrameTitleItem[]; currentIndex: number}, emit: Function, fName: string) {
  const titleList = ref(props.items);

  const currentIndex = ref(0);

  const handleClick = (value: number) => {
    if (currentIndex.value === value) return;
    currentIndex.value = value;
    emit(fName, value);
  };

  onMounted(() => {
    if (props.currentIndex === undefined) {
      currentIndex.value = 0;
    } else {
      currentIndex.value = props.currentIndex;
    }
  });
  watch(() => props.currentIndex, (index) => {
    currentIndex.value = index;
  });

  return {
    titleList,
    currentIndex,
    handleClick,
  };
}
